// A feed card's takes: the producer's versions of one song, newest first as
// the API sends them, numbered oldest-first the way a producer thinks of them
// ("take 1" is the first one they put up).

import type { FeedTake } from "@shared/api-types.js";

/** 1-based number of `id` among `takes`, counting from the oldest. */
export function takeNumber(takes: FeedTake[], id: string): number {
  const i = takes.findIndex((t) => t.id === id);
  return i < 0 ? takes.length : takes.length - i;
}

/** The takes oldest first, each with its number — what a switcher lists. */
export function numberedTakes(takes: FeedTake[]): Array<FeedTake & { n: number }> {
  return [...takes].reverse().map((t, i) => ({ ...t, n: i + 1 }));
}
